import React from 'react';
import { CreateForm } from 'framework/form';
import UploadWbsModal from './UploadWBSModal';
import useProjectsWBSDashboardService from '../useProjectsWBSDashboardService';
import { useListContext } from 'framework/list';
import { UPLOAD_WBS_MESSAGE_CONTEXT } from './constants';
import type { UploadWbsFormProps } from './types';

const UploadWbsForm = ({ closeModal }: UploadWbsFormProps) => {
  const { reloadData = () => {} } = useListContext();
  const { uploadWBS, getValidationSchema } = useProjectsWBSDashboardService();

  return (
    <CreateForm
      submitFormFunc={uploadWBS}
      messageContext={UPLOAD_WBS_MESSAGE_CONTEXT}
      getValidationSchemaFunc={getValidationSchema}
      afterSubmit={{
        execute: () => {
          reloadData();
          closeModal();
        },
      }}
    >
      <UploadWbsModal closeModal={closeModal} />
    </CreateForm>
  );
};

export default UploadWbsForm;
